module.exports = __webpack_public_path__ + "img/legendCriticalWard.255bbc61.svg";